import { render, staticRenderFns } from "./TrademarkSale.vue?vue&type=template&id=20d3b2ab&scoped=true"
import script from "./TrademarkSale.vue?vue&type=script&lang=js"
export * from "./TrademarkSale.vue?vue&type=script&lang=js"
import style0 from "./TrademarkSale.vue?vue&type=style&index=0&id=20d3b2ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3b2ab",
  null
  
)

export default component.exports